// frontend/src/components/MemberCard.js

import React, { useState } from "react";
import ImageLightbox from "./ImageLightbox";
import "../styles/member-card.css";

const MemberCard = ({ member }) => {
  const [open, setOpen] = useState(false);

  // Support multiple images or fallback to single photo
  const images = member?.images || (member?.photo ? [member.photo] : []);

  if (!member) return null;

  return (
    <>
      <div className="member-card">

        {/* MEMBER PHOTO */}
        {images.length > 0 && (
          <div
            className="member-photo"
            onClick={() => setOpen(true)}
            style={{ cursor: "pointer" }}
          >
            <img src={images[0]} alt={member.name} />
          </div>
        )}

        {/* MEMBER INFO */}
        <div className="member-info">

          {/* MEMBER NAME */}
          <h3 className="member-name">
            {member.name}
          </h3>

          {/* DESIGNATION / ROLE */}
          {(member.designation || member.role) && (
            <span className="member-designation">
              {member.designation || member.role}
            </span>
          )}

          {/* BIO */}
          {member.bio && (
            <p className="member-bio">
              {member.bio}
            </p>
          )}

        </div>
      </div>

      {/* IMAGE LIGHTBOX / FULLSCREEN */}
      {images.length > 0 && (
        <ImageLightbox
          images={images}
          open={open}
          setOpen={setOpen}
        />
      )}
    </>
  );
};

export default MemberCard;